import { Notify, Toast } from 'vant'
import axios from 'axios'
import { setToken, getToken, clearToken,getSchoolCode } from './auth'
import { removeLocal } from './cookie.js'
import { setWeixinJSBridge } from "@/utils/wx"
import {router} from '../router/index.js'
import qs from "qs"
const API_PREFIX = '/api'

const BASE_URL = API_PREFIX

axios.defaults.baseURL = BASE_URL
axios.defaults.timeout = 30000

export const METHOD = {
  POST: 'post',
  GET: 'get'
}

export function request(url, method, params, config) {
  switch (method) {
    case METHOD.POST:
      return axios.post(url, params, config)
    case METHOD.GET:
      return axios.get(url, Object.assign({}, config, { params }))
  }
}

/**
 * 加载 axios 拦截器
 * @param interceptors
 * @param options
 */
export function loadInterceptors() {
  axios.interceptors.request.use(
    config => {
      if (!config.noAuth) {
        config.headers['Authorization'] = getToken()
        config.headers['Authorization-So'] = getSchoolCode()&&getSchoolCode().schoolCode||'LONGMAO'
      }

      if (!config.hideLoading) {
        Toast.loading({
          message: config.loadingText || '加载中...',
          forbidClick: true,
          duration: 0,
        });
      }
      return config
    },
    error => {
    console.error(error)
      // Notify({
      //   type: 'danger',
      //   message: error.message
      // })
      return error
    }
  )

  axios.interceptors.response.use(
    response => {

      // if (response.data.header && response.data.header.bizCode && response.data.header.bizCode == -199) {
      //   clearToken()
      //   WeixinJSBridge.call('closeWindow');
      // }
      if (response.status != 200) {
        const message = response.data.error
        Notify({
          type: 'danger',
          message
        })
        return Promise.error({
          message,
          response
        })
      } else {
        const { status, header } = response.data
        if (status && status != '00') {
          // tokenNullErrorCode("-6013"),
          // tokenNullErrorMsg("toekn为空,禁止访问"),
          
          // tokenTimeOutErrorCode("-6014"),
          // tokenTimeOutErrorMsg("token已过期，请重新登录"),
          
          // personTypeErrorCode("-6015"),
          // personTypeErrorMsg("无使用类型人员"),
          
          // persoFaceNullErrorCode("-6016"),
          // persoFaceNullErrorMsg("请先申请准考证"),
          // personBindErrorCode("-6017"),
          // personBindErrorMsg("账号未绑定"),

          const message = response.data.msg
          Toast.clear();
          Notify({
            type: 'danger',
            message
          })
       
          // location.reload()

          return Promise.reject({
            response,
            message
          })
        } else if (header && header.code != 0) {
          if (header.bizType=='-6015') {
            // 如果没绑定身份
            // router.push({path:'parentReg',query:{identity:'teacher'}})
            // router.push({path:'parentReg',query:{identity:'teacher'}})
          }
     
          if (header.bizCode == -199||header.bizCode == -6014) {
            removeLocal("Authorization")
            location.reload()
            // clearToken();
            // setWeixinJSBridge();
          }
          Toast.clear();
          const message = header.msg
          Notify({
            type: 'danger',
            message,
            onClose: () => {
            },
          })
          
        
          return Promise.reject({
            response,
            message
          })
        }
      }
      Toast.clear()
      // const newToken = response.data.token || undefined
      // newToken && setToken(newToken);
      return response
    },
    (error, message) => {
      console.log(error);
      // 任何异常路径都必须清除加载圈，否则“加载中...”会永久卡住
      try {
        if (error.response && error.response.status == 401) {
          // token失效
          removeLocal("Authorization")
          clearToken()
          WeixinJSBridge.call('closeWindow');
        }

        // error.response 可能为 undefined（请求被中断/超时/断网），必须先判空
        let errorMessage = '网络异常，请检查网络后重试！'
        if (error.response) {
          if (error.response.status == 404) {
            errorMessage = '接口异常，请稍后重试！'
          } else if (error.response.status == 500) {
            errorMessage = '数据错误，请稍后重试！'
          } else if (error.response.status == 503) {
            errorMessage = '程序正在维护，请稍后重试！'
          }
        }
        Notify({
          type: 'danger',
          message: errorMessage
        })
      } catch (e) {
        console.error(e)
      } finally {
        Toast.clear()
      }
      return Promise.reject(error)
    }
  )
}

/**
 * 解析 url 中的参数
 * @param url
 * @returns {Object}
 */
export function parseUrlParams(url) {
  const params = {}
  if (!url || url === '' || typeof url !== 'string') {
    return params
  }
  const paramsStr = url.split('?')[1]
  if (!paramsStr) {
    return params
  }
  const paramsArr = paramsStr.replace(/&|=/g, ' ').split(' ')
  for (let i = 0; i < paramsArr.length / 2; i++) {
    const value = paramsArr[i * 2 + 1]
    params[paramsArr[i * 2]] = value === 'true' ? true : (value === 'false' ? false : value)
  }
  return params
}
